import { Component } from '@angular/core';
import { CollectionUserApi, OrganizationContractService } from '@shared/services/contract.service';
import { ContractSite } from '@shared/models/contract';
import { UserContractCollection } from '../UserContractCollection';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { HostModeLabelComponent } from '@shared/components/label/host-mode-label/host-mode-label.component';
import { ManagedServiceLabelComponent } from '@shared/components/label/managed-service-label/managed-service-label.component';
import { SiteStatusFullComponent } from '@shared/components/site-status-full/site-status-full.component';
import { TablePagerComponent } from '@shared/components/table-pager/table-pager.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-contract-sites',
  templateUrl: './contract-sites.component.html',
  imports: [
    NgxDatatableModule,
    HostModeLabelComponent,
    ManagedServiceLabelComponent,
    SiteStatusFullComponent,
    TablePagerComponent,
    TranslatePipe,
  ],
})
export class ContractSitesComponent extends UserContractCollection<ContractSite> {
  constructor(protected userContractService: OrganizationContractService) {
    super(userContractService);
  }

  // TODO bandwidth was been hidden until have an endpoint for that.
  override getCollectionApi(): CollectionUserApi<ContractSite> {
    return this.userContractService.sites(this.contractNumber);
  }
}
